module.exports = __webpack_public_path__ + "img/title_bg.1248abc8.png";